import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';

export interface ConfirmDialogData {
  title?: string;
  message: string;
  /** Confirm button text, default: "Yes" */
  confirmButtonText?: string;
  /** Confirm button text, default: "Cancel" */
  cancelButtonText?: string;
}


@Component({
  selector: 'app-confirm-dialog',
  templateUrl: 'confirm-dialog.component.html',
})
export class ConfirmDialogComponent {

  confirmButtonText = this.data.confirmButtonText || 'Yes';
  cancelButtonText = this.data.cancelButtonText || 'Cancel';

  static open(dialog: MatDialog, config: MatDialogConfig<ConfirmDialogData>) {
    return dialog.open<ConfirmDialogComponent, ConfirmDialogData, boolean>(ConfirmDialogComponent, config);
  }

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) { }

  choiceClicked(result: boolean): void {
    this.dialogRef.close(result);
  }
}
